import React from 'react'
import { useTranslation } from 'react-i18next'
function SliderLabelsCompare({ sliderValue }) {
    const { t } = useTranslation()
    return (
        <div className="how-slider-names">
            <div className="how-slider-name">
                <div className="flex flex-col items-start ">
                    <div className="flex flex-col justify-center items-start gap-1 ">
                        <div
                            className="how-slider-name-text w-[34px] h-[30px] leading-[15px]"
                            style={{ marginLeft: -16, color: sliderValue === 0 ? 'var(--deep-ocean)' : 'var(--grey)' }}
                        >
                            {t('muchWorse').toLowerCase()}
                        </div>
                        <div className="how-slider-name-vertical-stick w-[3px]" style={{ backgroundColor: sliderValue === 0 ? 'var(--deep-ocean)' : 'var(--grey)' }}></div>
                    </div>
                </div>
                <div className="how-slider-down"></div>
            </div>
            <div className="how-slider-name">
                <div className=" flex  flex-col items-start">
                    <div className="flex items-start justify-center flex-col gap-1">
                        <div className="how-slider-name-text mt-[15px] leading-[15px]" style={{ marginLeft: -16, color: sliderValue === 1 ? 'var(--deep-ocean)' : 'var(--grey)' }}>
                            {t('worse').toLowerCase()}
                        </div>
                        <div className="how-slider-name-vertical-stick" style={{ backgroundColor: sliderValue === 1 ? 'var(--deep-ocean)' : 'var(--grey)' }}></div>
                    </div>
                </div>

                <div className="how-slider-down"></div>
            </div>
            <div className="how-slider-name items-start">
                <div className="flex flex-col items-start ">
                    <div className="flex flex-col justify-center items-start gap-1 ">
                        <div
                            className="how-slider-name-text mt-[15px] leading-[15px] text-center w-full"
                            style={{ marginLeft: -15, color: sliderValue === 2 ? 'var(--deep-ocean)' : 'var(--grey)' }}
                        >
                            {t('same').toLowerCase()}
                        </div>
                        <div className="how-slider-name-vertical-stick -ml-[1px] " style={{ backgroundColor: sliderValue === 2 ? 'var(--deep-ocean)' : 'var(--grey)' }}></div>
                    </div>
                </div>
                <div className="how-slider-down">
                    <div className="flex flex-col-reverse items-end justify-center">
                        <div className="how-slider-name-text w-full" style={{ marginRight: -7, color: sliderValue === 3 ? 'var(--deep-ocean)' : 'var(--grey)' }}>
                            {t('better').toLowerCase()}
                        </div>
                        <div className="how-slider-name-vertical-stick " style={{ backgroundColor: sliderValue === 3 ? 'var(--deep-ocean)' : 'var(--grey)' }}></div>
                    </div>
                </div>
            </div>
            <div className="how-slider-name">
                <div className="how-slider-up"></div>
                <div className="how-slider-down justify-end">
                    <div className="flex flex-col-reverse items-end justify-center">
                        <div className="how-slider-name-text w-[34px]" style={{ marginRight: -16, color: sliderValue === 4 ? 'var(--deep-ocean)' : 'var(--grey)' }}>
                            {t('muchBetter').toLowerCase()}
                        </div>
                        <div className="how-slider-name-vertical-stick" style={{ backgroundColor: sliderValue === 4 ? 'var(--deep-ocean)' : 'var(--grey)' }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SliderLabelsCompare
